import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import * as d3 from "d3";
import { truncate } from 'fs';
import { Subscription, of } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { DynamicCustomTooltipService } from 'src/app/services/dynamic-custom-tooltip.service';
import { FilterService } from 'src/app/services/filter.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-basic-line-chart-grid',
  templateUrl: './basic-line-chart-grid.component.html',
  styleUrls: ['./basic-line-chart-grid.component.scss']
})
export class BasicLineChartGridComponent implements ICellRendererAngularComp {
  bubblemaplinechartdata: any = []
  divId: any = 'gridLineChartContainer';
  props: any = {};
  @ViewChild("gridLineChartContainer", { static: true }) gridLineChartContainer!: ElementRef;
  @ViewChild('linesChartTooltip') linesChartTooltip!: ElementRef|any;
  reqSubcription: Subscription[] = [];
  public params: any;
  loader = true;
  error_name: any;
  tooltipVisible: boolean = false;
  mytooltipData: any = null;
  isBrushing = false;


  // Required by AG Grid
  agInit(params: any): void {
    this.params = params;
    // debugger
    this.divId = this.divId + "_" + this.params?.rowIndex;
    this.initiateCharts();
    this.loader = true;
    this.loadApiData();
  }

  ngAfterViewInit(): void {
    // Tell grid to recalc heights once content is painted
    setTimeout(() => {
      this.params.api.resetRowHeights();
    }, 100);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    setTimeout(() => {
      this.plotChart()
    }, 0);
  }

  // Optional: refresh is used if the grid asks to re-render
  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  constructor(
    private apiService: ApiService,
    private filterService: FilterService,
    private cdr: ChangeDetectorRef,
    private viewContainerRef: ViewContainerRef,
    private dynamicCustomTooltipService: DynamicCustomTooltipService
  ) { }
 private showTooltip(event: any, myData: any, myX: any, myY: any): void {
    // console.log('show tooltip', myData);

    // Create an array to hold data for each series shown in the tooltip
    const tooltipSeriesData: any[] = [];

    // 1. Add the Main Line Data (Unlinked Patient Volume)
    // Assuming the main line corresponds to props.yAxisVar
    // const mainLineValue = myData[1]; // The value from the dateGroupMain data
    // tooltipSeriesData.push({
    //   colour: this.props.colour || '#BB7EDA', // Use the main line color
    //   label: 'Unlinked Patient Volume',
    //   value: mainLineValue
    // });

    // 3. Add Bar Data (Total Triage Patients)
    // Find the bar value for this date
    const originalDataPointForBar = this.bubblemaplinechartdata.find((d:any) => new Date(d[this.props.xAxisVar]).getTime() === myData[0].getTime());
    if (originalDataPointForBar) {
      const barValue = originalDataPointForBar[this.props.barVar];
      tooltipSeriesData.push({
        colour: this.props.barColor || '#B0D4F0', // Use the bar color
        label: 'Total Triaged Patients (As of Today)',
        value: barValue,
        date: originalDataPointForBar[this.props.xAxisVar]

      });
    }
    // 2. Add Dynamic Lines Data
    if (this.props.dynamicLines && Array.isArray(this.props.dynamicLines)) {
      this.props.dynamicLines.forEach((line: any) => {
        // Find the value for this dynamic line at the same date
        const originalDataPoint = this.bubblemaplinechartdata.find((d:any) => new Date(d[this.props.xAxisVar]).getTime() === myData[0].getTime());
        if (originalDataPoint) {
          const dynamicValue = originalDataPoint[line.var];
          tooltipSeriesData.push({
            colour: line.color || '#FF5757', // Use the dynamic line color
            label: line.label || line.var, // Use the label from config, fallback to var name
            value: dynamicValue,
            date:originalDataPoint[this.props.xAxisVar]
          });
        }
      });
    }


    // Set the tooltip data
    this.mytooltipData = tooltipSeriesData;

  
    

    this.tooltipVisible = true;
    this.dynamicCustomTooltipService.createMouseTooltip(this.linesChartTooltip, this.viewContainerRef, event);

  }

  // [NEW] hideTooltip function (simplified)
  private hideTooltip(myType: any): void {
   this.dynamicCustomTooltipService.hideMouseTooltip();
    this.tooltipVisible = false;
    this.mytooltipData = null; // Clear data when hiding
    // this.cdr.detectChanges(); // Trigger change detection
  }

  // ... (initiateCharts, plotChart, loadApiData remain mostly the same, see below for minor changes) ...


  ngOnInit(): void {
    // this.initiateCharts();
    // this.getBubblemapLineChartData();
  }

  // initiateCharts renders the svg AND any non-data appended elements
  initiateCharts(): void {
    // only need to call this once on initialisation
    
    const myChart = this;
    const myClass = myChart.divId;
    
    const height = 350; // Fixed height
    const mySvg = d3.select(this.gridLineChartContainer.nativeElement)
      .append('svg')
      .attr('id', 'svg_' + myClass)
      .attr('width', '100%')
      .attr('height', height)
      .style('background-color', 'white');

    const defs = mySvg.append('defs');

    defs.append('clipPath').attr('id', 'bmlBrushClip' + myClass)
      .append('rect').attr('id', 'bmlBrushClipRect' + myClass);

    const filter: any = defs.append('filter').attr('id', 'drop-shadow').attr('width', 10).attr('height', 24);
    filter.append('feGaussianBlur').attr('in', 'SourceAlpha').attr('stdDeviation', 1).attr('result', 'blur');
    filter.append('feOffset').attr('in', 'blur').attr('dx', 1)
      .attr('dy', 1).attr('result', 'offsetBlur');
    filter.append('feFlood').attr('in', 'offsetBlur')
      .attr('flood-color', '#000000').attr('flood-opacity', 0.4)
      .attr('result', 'offsetColor');
    filter.append('feComposite').attr('in', 'offsetColor').attr('in2', 'offsetBlur').attr('operator', 'in').attr('result', 'offsetBlur');
    const feMerge = filter.append('feMerge');
    feMerge.append('feMergeNode').attr('in', 'offsetBlur');
    feMerge.append('feMergeNode').attr('in', 'SourceGraphic');

  
    // Main elements
    // mySvg.append('circle').attr('id', 'legendCircle' + myClass);
    // mySvg.append('text').attr('id', 'legendLabel' + myClass)
    mySvg.append('g').attr('id', 'brushbarGroup' + myClass);      // bars (bottom)
    mySvg.append('g').attr('id', 'brushLinesGroup' + myClass);    // dynamic/main lines (middle)
    mySvg.append('g').attr('id', 'brushDotsGroup' + myClass);     // dots (TOP)
    mySvg.append('text').attr('id', 'xAxisLabel' + myClass);
    mySvg.append('text').attr('id', 'yAxisLabel' + myClass);
    mySvg.append('text').attr('id', 'yAxisLabelRight' + myClass);
    mySvg.append('g').attr('id', 'xAxis' + myClass).attr('class', 'axis' + myClass);
    mySvg.append('g').attr('id', 'yAxis' + myClass).attr('class', 'axis' + myClass);
    mySvg.append('g').attr('id', 'yAxisRight' + myClass).attr('class', 'axis' + myClass);
    // Add group for bars - positioned before line/area paths so bars appear behind
    mySvg.append('g').attr('id', 'barGroup' + myClass);
    mySvg.append('g').attr('id', 'dotsGroup' + myClass);
    
    // Add group for bar value labels - positioned above bars
    // mySvg.append('g').attr('id', 'barValueLabels' + myClass); // [NEW] Add label group
    mySvg.append('path').attr('id', 'areaPath' + myClass);
    mySvg.append('path').attr('id', 'linePath' + myClass); // Main line path
    mySvg.append('path').attr('id', 'dot' + myClass);
    mySvg.append('g').attr('id', 'brushGroup' + myClass)
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleLeftLine1' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleLeftLine2' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleRightLine1' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleRightLine2' + myClass);
    mySvg.append("linearGradient")
    .attr("id", "area-gradient")
    .attr("gradientUnits", "userSpaceOnUse")
    .attr("x1", 0) .attr("x2", 0)
    .selectAll("stop")
    .data([ {offset: "0%", color: "black"}, {offset: "100%", color: "white"} ])
    .enter().append("stop")
    .attr("id", (d,i) => i === 0 ? "zeroStop" : "")
    .attr("offset", (d: any) => d.offset)
    .attr("stop-color", (d: any) => d.color);
    // mySvg.append('line').attr('id', 'mouseoverLine' + myClass);
    // mySvg.append('circle').attr('id', 'mouseoverDot' + myClass);
    // mySvg.append('rect').attr('id', 'mouseoverRect' + myClass);
    mySvg.append('line').attr('class', 'barMouseoverLine' + myClass + ' barMouseoverItem' + myClass);
    mySvg.append('rect').attr('class', 'barMouseoverRect' + myClass + ' barMouseoverItem' + myClass);
    mySvg.append('text').attr('class', 'barMouseoverText' + myClass + ' barMouseoverItem' + myClass);
    mySvg.append('line').attr('class', 'lineMouseoverLine' + myClass + ' lineMouseoverItem' + myClass);
    mySvg.append('rect').attr('class', 'lineMouseoverRect' + myClass + ' lineMouseoverItem' + myClass);
    mySvg.append('text').attr('class', 'lineMouseoverText' + myClass + ' lineMouseoverItem' + myClass);
    

  }

  plotChart(): void {
    // define core elements
    const myChart: any = this;
    const myClass = myChart.divId;
    const mySvg: any = d3.select('#svg_' + myClass);
    const width = d3.select(this.gridLineChartContainer.nativeElement).node().getBoundingClientRect().width;
    const height = myChart.props.chartHeight;
    const allData = myChart.bubblemaplinechartdata;
    let margins = { left: 50, right: 55, top: 30, bottom: 80, brush: 40};
    // different margins if no brush
    if(myChart.props.showBrush === false){
      margins.brush = 0;
      margins.bottom = 50;
    }
    let isBrushing = false;

    // console.log("Props: ", myChart.props); // [DEBUG]
    // console.log("All Data: ", allData); // [DEBUG]
    
    // map dates to full dates
    allData.map((m: any) => m.date = new Date(m[myChart.props.xAxisVar]));
    // debugger
    // Create data arrays for each series
    const dateGroupMain: any = Array.from(d3.rollup(allData, (r: any) => d3.sum(r, (s: any) => s[myChart.props.yAxisVar]), (g: any) =>  g.date));
    const dateGroupBar: any = Array.from(d3.rollup(allData, (r: any) => d3.sum(r, (s: any) => s[myChart.props.barVar]), (g: any) =>  g.date));
    
    // console.log("Date Group Main (Line Data): ", dateGroupMain); // [DEBUG]
    // console.log("Date Group Bar (Bar Data): ", dateGroupBar); // [DEBUG]

    // Dynamic lines data
    const dynamicLineData: any[] = [];
    if (myChart.props.dynamicLines && Array.isArray(myChart.props.dynamicLines)) {
      myChart.props.dynamicLines.forEach((_line: any, index: number) => {
        const lineData = Array.from(d3.rollup(allData, (r: any) => d3.sum(r, (s: any) => s[_line.var]), (g: any) => g.date));
        dynamicLineData.push({ index, data: lineData, config: _line });
        // console.log(`Dynamic Line ${_line.var} Data:`, lineData); // [DEBUG]
      });
    }
    
    // define date group
    const dateGroupDates = dateGroupMain.map((m: any) => m[0]);
    
    // define x tick format (used in line, bar, combo, gantt, area charts as well)
    const tickFormat: any = {"D": "%d %b %y", "W": "%d %b %y", "M": "%b %Y", "Q": "%b %Y", "Y": "%Y"};
    const timePeriod = this.props.period;
    const timeConverter: any = {
      D: d3.timeDay,
      W: d3.timeWeek,
      M: d3.timeMonth,
      Q: d3.timeMonth,
      Y: d3.timeYear,
      PCQ: d3.timeMonth,
    };

    const xTickFormat = d3.timeFormat(tickFormat[timePeriod]);
    
    // Calculate max values for both scales
    let yMaxMain: any = d3.max(dateGroupMain, (d: any) => d[1]);
    if (myChart.props.dynamicLines && Array.isArray(myChart.props.dynamicLines)) {
        myChart.props.dynamicLines.forEach((_line: any, index: number) => {
            const pathId = `dynamicLinePath_${index}_${_line.var}` + myClass;
            // Check if the path already exists before appending
            if (mySvg.select('#' + pathId).empty()) {
                // console.log(`Creating path element for dynamic line ${index} (${_line.var}) with ID: ${pathId}`); // [DEBUG]
                mySvg.append('path').attr('id', pathId);
            } else {
                // console.log(`Path element for dynamic line ${index} (${_line.var}) with ID: ${pathId} already exists.`); // [DEBUG]
            }
        });
    } else {
        // console.log("No dynamic lines defined or not an array, skipping dynamic path creation."); // [DEBUG]
    }
    // --- CREATE DYNAMIC BRUSH PATHS ---
if (myChart.props.dynamicLines && Array.isArray(myChart.props.dynamicLines)) {
  myChart.props.dynamicLines.forEach((_line: any, index: number) => {

    const brushPathId = `dynamicBrushLinePath_${index}_${_line.var}` + myClass;

    if (mySvg.select('#' + brushPathId).empty()) {
      mySvg.append('path').attr('id', brushPathId);
    }
  });
}

    
    // Check if there are dynamic lines to include in yMax calculation
    if (myChart.props.dynamicLines && Array.isArray(myChart.props.dynamicLines)) {
      myChart.props.dynamicLines.forEach((_line: any) => {
        const lineData = Array.from(d3.rollup(allData, (r: any) => d3.sum(r, (s: any) => s[_line.var]), (g: any) => g.date));
        const lineMax = d3.max(lineData, (d: any) => d[1]);
        if (lineMax > yMaxMain) yMaxMain = lineMax;
      });
    }
    
    yMaxMain = yMaxMain * 1.1; // add 10% headroom
    
    // Calculate max for bar values for right axis
    let yMaxBar: any = d3.max(dateGroupBar, (d: any) => d[1]);
    yMaxBar = yMaxBar * 1.1; // add 10% headroom
    
    let xExtent: any = d3.extent(dateGroupMain, (d: any) => d[0]);
    const lastDay1Or2 = +d3.timeFormat("%d")(xExtent[1]) <= 2 ? false : false;
    
    // as with all brush charts there is an All X scale (the brush, does not change)
    // and a standard X scale - which changes as user interacts with the brush
    // and is used to draw the chart element
     const paddedDomain: [Date, Date] = [
      timeConverter[timePeriod].offset(xExtent[0], -1),  // 1 day before min
      timeConverter[timePeriod].offset(xExtent[1], +1)   // 1 day after max
    ];
      const xExtentBrush: [Date, Date] = [
      timeConverter[timePeriod].offset(xExtent[0], -1),  // 1 day before min
      timeConverter[timePeriod].offset(xExtent[1], +1)   // 1 day after max
    ];
    const xScaleAll: any = d3.scaleTime().range([0, width - margins.left - margins.right]).domain(paddedDomain);
    const xScale: any = d3.scaleTime().range([0, width - margins.left - margins.right]).domain(paddedDomain);
    const yScaleMain: any = d3.scaleLinear().domain([0, yMaxMain]).range([height - margins.top - margins.bottom, 0]);
    // Right axis scale for bar values
    const yScaleRight: any = d3.scaleLinear().domain([0, yMaxBar]).range([height - margins.top - margins.bottom, 0]);
    
    // brush scales same as All but have smaller range
    const xScaleBrush: any = d3.scaleTime().range([0, width - margins.left - margins.right]).domain(xExtentBrush);
    const yScaleBrush: any = d3.scaleLinear().domain([0, yMaxMain]).range([margins.brush, 0]);//line
    const yScalerightBrush: any = d3.scaleLinear().domain([0, yMaxBar]).range([margins.brush, 0]);//bar
    
    // line and area definitions
    const line: any = d3.line()
      // .curve(d3.curveMonotoneX)
      .x((d: any) => xScale(d[0]))
      .y((d: any) =>  yScaleMain(d[1]));

    const lineBrush: any = d3.line()
      // .curve(d3.curveMonotoneX)
      .x((d: any) => xScaleBrush(d[0]))
      .y((d: any) =>  yScaleBrush(d[1]));

    const area: any = d3.area()
      // .curve(d3.curveMonotoneX)
      .x((d: any) => xScale(d[0]))
      .y0((d: any) =>  yScaleMain(d[1]))
      .y1( yScaleMain(0));

    // Bar chart settings
    const barPadding = myChart.props.barPadding || 0.1; // Dynamic bar padding
    const barWidth = (width - margins.left - margins.right) / dateGroupBar.length * (1 - barPadding);
    const barGroupWidth = (width - margins.left - margins.right) / dateGroupBar.length;
    const chartWidth = width - margins.left - margins.right 
    // x brush definition
    const brush: any = d3.brushX()
      .handleSize(10)
      .extent([[0, 0], [width - margins.left - margins.right, margins.brush]])
      .on('start brush end', brushed);
       // mouseover line
    mySvg.select('.barMouseoverLine' + myClass)
      .attr("visibility", "hidden")
      .attr("x2", width - margins.right)
      // .attr('stroke', '#1468E1')
      .attr('stroke-dasharray', '2,2');
    // additional mouseover rect and text on right for this chart only
    mySvg.select('.barMouseoverRect' + myClass)
      .attr("visibility", "hidden")
      .attr("x", width - margins.right + 2)
      .attr('width', 40)
      .attr('height', 12)
      .attr('rx', 4)
      .attr('ry', 4)
      // .attr('fill', '#1468E1');

    mySvg.select('.barMouseoverText' + myClass)
      .attr("visibility", "hidden")
      .attr("x", width - margins.right + 2 + 20)
      .attr('text-anchor', "middle")
      .style('font-family', 'Poppins')
      .style('font-weight', 500)
      .style('font-size', 10)
      .attr('dy', 4)
      .attr('fill', 'white');

    mySvg.select('.lineMouseoverLine' + myClass)
      .attr("visibility", "hidden")
      .attr("x1", margins.left) // Line starts from the left edge
      .attr('stroke-dasharray', '2,2');

    // Line/Dot mouseover rect and text (LEFT axis) - Positioned near the left edge initially
    mySvg.select('.lineMouseoverRect' + myClass)
      .attr("visibility", "hidden")
      .attr("x", margins.left - 42) // Positioned to the left of the left axis
      .attr('width', 40)
      .attr('height', 12)
      .attr('rx', 4)
      .attr('ry', 4);
    mySvg.select('.lineMouseoverText' + myClass)
      .attr("visibility", "hidden")
      .attr("x", margins.left - 20) // Centered in the rect
      .attr('text-anchor', "middle")
      .style('font-family', 'Poppins')
      .style('font-weight', 500)
      .style('font-size', 10)
      .attr('dy', 4)
      .attr('fill', 'white');

    // legend circle and label - only 1 so no data appending
     drawLegend(Object.keys(myChart.props.barFill));
      
    // axis labels
    d3.select('#xAxisLabel' + myClass)
      .attr('x', margins.left + ((width - margins.left - margins.right)/2))
      .attr('y', height  - margins.brush - 17)
      .attr('text-anchor', 'middle')
      .attr('font-family', 'Poppins')
      .attr('fill', '#101D42')
      .attr('font-size', '12px')
      // @ts-ignore
      .text(myChart.props.xAxisLabel);

    d3.select('#yAxisLabel' + myClass)
      .attr('transform','translate(13,' + (margins.top + ((height - margins.top - margins.bottom - margins.brush)/2)) + ') rotate(-90)')
      .attr('text-anchor', 'middle')
      .attr('font-family', 'Poppins')
      .attr('fill', '#101D42')
      .attr('font-size', '12px')
      // @ts-ignore
      .text(myChart.props.yAxisLabel);
      
    d3.select('#yAxisLabelRight' + myClass)
      .attr('transform','translate(' + (width - 13) + ',' + (margins.top + ((height - margins.top - margins.bottom - margins.brush)/2)) + ') rotate(-90)')
      .attr('text-anchor', 'middle')
      .attr('font-family', 'Poppins')
      .attr('fill', '#101D42')
      .attr('font-size', '12px')
      // @ts-ignore
      .text(myChart.props.yAxisLabelRight);
      
    // clip rect for brush
    mySvg.select('#bmlBrushClipRect' + myClass)
      .style('width', chartWidth)
      .style('height', height)
      .attr('transform', 'translate(0,-20)');

if (myChart.props.showBrush) {

  const brushY = height - margins.brush - 10;
  const brushTransform = `translate(${margins.left},${brushY})`;

  // -----------------------------------------------------
  // 1. BRUSH GROUP INIT
  // -----------------------------------------------------
  mySvg.select('#brushGroup' + myClass)
    .attr('transform', brushTransform)
    .call(brush)
    .call(brush.move, [0, width - margins.left - margins.right]);


  // -----------------------------------------------------
  // 2. BRUSH BARS (bottom layer)
  // -----------------------------------------------------
  mySvg.select('#brushbarGroup' + myClass)
    .attr('transform', brushTransform)
    .selectAll('.bar' + myClass)
    .data(dateGroupBar, (d: any) => d[0])
    .join(
      (enter:any) => enter.append('rect')
        .attr('class', 'bar' + myClass)
        .attr('fill', myChart.props.barColor)
        .attr('opacity', myChart.props.barOpacity),
      (update:any) => update,
      (exit:any) => exit.remove()
    )
    .attr('x', (d: any) => xScaleBrush(d[0]) - (myChart.props.barWidth || barWidth) / 2)
    .attr('y', (d: any) => yScalerightBrush(d[1]))
    .attr('width', myChart.props.barWidth || barWidth)
    .attr('height', (d: any) => margins.brush - yScalerightBrush(d[1]));


  // --------------------------------------------------------------------
  // 3. BRUSH LINES + DOTS (Dynamic OR Main)
  // --------------------------------------------------------------------
  const hasDynamic = myChart.props.dynamicLines?.length > 0;

  if (hasDynamic) {
    // -------------------------
    // DYNAMIC LINES + DOTS
    // -------------------------
    myChart.props.dynamicLines.forEach((_line: any, index: number) => {

      const lineData = Array.from(
        d3.rollup(
          allData,
          (r: any) => d3.sum(r, (s: any) => s[_line.var]),
          (g: any) => g.date
        )
      );

      // ===== BRUSH LINE (middle layer) =====
      const brushPathId = `dynamicBrushLinePath_${index}_${_line.var}${myClass}`;

      mySvg.select('#brushLinesGroup' + myClass)
        .selectAll(`#${brushPathId}`)
        .data([lineData])
        .join(
          (enter:any) => enter.append('path').attr('id', brushPathId),
          (update:any) => update
        )
        .attr('d', lineBrush(lineData))
        .attr('fill', 'transparent')
        .attr('stroke', _line.color)
        .attr('stroke-width', _line.width || 3)
        .attr('clip-path', `url(#bmlBrushClip${myClass})`)
        .attr('transform', brushTransform);

      // ===== BRUSH DOTS (TOP layer) =====
      mySvg.select('#brushDotsGroup' + myClass)
        .selectAll(`.dotbrush_${index}${myClass}`)
        .data(lineData, (d: any) => d[0])
        .join(
          (enter:any) => enter.append('circle')
            .attr('class', `dotbrush_${index}${myClass}`)
            .attr('r', 3)
            .attr('stroke', _line.color)
            .attr('stroke-width', 2)
            .attr('fill', '#fff')
            .attr('clip-path', `url(#bmlBrushClip${myClass})`),
          (update:any) => update,
          (exit:any) => exit.remove()
        )
        .attr('cx', (d: any) => xScaleBrush(d[0]))
        .attr('cy', (d: any) => yScaleBrush(d[1]))
        .attr('transform', brushTransform);
    });

  } else {
    // -------------------------
    // MAIN LINE + DOTS (fallback)
    // -------------------------
    mySvg.select('#brushLinesGroup' + myClass)
      .selectAll(`#brushLinePath${myClass}`)
      .data([dateGroupMain])
      .join(
        (enter:any) => enter.append('path').attr('id', `brushLinePath${myClass}`),
        (update:any) => update
      )
      .attr('d', lineBrush(dateGroupMain))
      .attr('fill', 'transparent')
      .attr('stroke', myChart.props.colour)
      .attr('stroke-width', 4)
      .attr('clip-path', `url(#bmlBrushClip${myClass})`)
      .attr('transform', brushTransform);

    mySvg.select('#brushDotsGroup' + myClass)
      .selectAll('.dotbrush' + myClass)
      .data(dateGroupMain, (d: any) => d[0])
      .join('circle')
      .attr('class', 'dotbrush' + myClass)
      .attr('r', 3)
      .attr('stroke', myChart.props.colour)
      .attr('stroke-width', 2)
      .attr('fill', '#fff')
      .attr('clip-path', `url(#bmlBrushClip${myClass})`)
      .attr('cx', (d: any) => xScaleBrush(d[0]))
      .attr('cy', (d: any) => yScaleBrush(d[1]))
      .attr('transform', brushTransform);
  }


  // -----------------------------------------------------
  // 4. BRUSH HANDLE LINES
  // -----------------------------------------------------
  const brushGroupSelection = mySvg.select('#brushGroup' + myClass);

  mySvg.selectAll('.handleLines' + myClass)
    .attr('y1', brushY + (margins.brush - 12) / 2)
    .attr('y2', brushY + (margins.brush + 12) / 2)
    .style('stroke', '#8A98AB')
    .style('stroke-width', 1)
    .attr('transform', `translate(${margins.left},0)`);

  brushGroupSelection.selectAll('.selection')
    .attr('fill', '#A0A0A0')
    .attr('fill-opacity', 0.2)
    .style('stroke', '#E8EAEE')
    .style('stroke-width', 1);


} else {
  // hide when brush disabled
  mySvg.select('#brushGroup' + myClass).html('');
  mySvg.selectAll('.handleLines' + myClass).style('stroke-width', 0);
  mySvg.select('#brushLinePath' + myClass).attr('d', '');
}



    
    // set chart height and width
    mySvg.attr("width", width)
      .attr("height", height);
      
    // mouseover rect for interaction
    mySvg.select("#mouseoverRect" + myClass)
      .attr("fill","transparent")
      .attr("width", width - margins.left - margins.right)
      .attr("height", height - margins.bottom - margins.top)
      .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')')
      .on("mousemove", (event: any) => {
        // get date of current position
        const positionDate = xScale.invert(event.offsetX - margins.left);
        // look in data for closest date to position date
        let closest: any = dateGroupDates.findIndex((f: any) => new Date(f) >= positionDate);
        // if not 1st entry
        if(closest > 0){
          // look left and right and decide if at the right spot
          const leftMinutes = d3.timeMinute.count(dateGroupDates[closest - 1], positionDate);
          const rightMinutes = Math.abs(d3.timeMinute.count(dateGroupDates[closest], positionDate));
          if(leftMinutes < rightMinutes){
            closest -= 1;
          }
        } else if(closest === -1){
          // out of range so go for the last entry
          closest = dateGroupDates.length - 1;
        }
        // position the mouseover line and dot
        d3.select('#mouseoverLine' + myClass)
          .attr('visibility', 'visible')
          .attr('x1', xScale(dateGroupMain[closest][0]))
          .attr('x2', xScale(dateGroupMain[closest][0]));

        d3.select('#mouseoverDot' + myClass)
          .attr('visibility', 'visible')
          .attr('cx', xScale(dateGroupMain[closest][0]))
          .attr('cy', yScaleMain(dateGroupMain[closest][1]));
        // show tooltip
        // myChart.showTooltip(event, dateGroupMain[closest], event.offsetX, event.offsetY);
      })
      .on('mouseout', () => {
        d3.select('#mouseoverLine' + myClass).attr('visibility', 'hidden');
        d3.select('#mouseoverDot' + myClass).attr('visibility', 'hidden');
        // myChart.hideTooltip('lineDot');
      });
      
    // set mouseover line style
    mySvg.select('#mouseoverLine' + myClass)
      .attr('visibility', 'hidden')
      .attr('pointer-events', 'none')
      .attr('stroke', '#A0A0A0')
      .attr('stroke-width', 3)
      .attr('y1', 0)
      .attr('y2', height - margins.top - margins.bottom)
      .attr('transform',  'translate(' + margins.left + ',' + margins.top + ')');
      
    // set mouseover dot style
    mySvg.select('#mouseoverDot' + myClass)
      .attr('visibility', 'hidden')
      .attr('pointer-events', 'none')
      .attr('r', 4)
      .attr('fill', myChart.props.colour)
      .attr('stroke', 'white')
      .attr('stroke-width', 1)
      .attr('transform',  'translate(' + margins.left + ',' + margins.top + ')');
      
    //set gradient y positions
    mySvg.select("#area-gradient")
      .attr("y1", yScaleMain(yMaxMain))
      .attr("y2", yScaleMain(0));
      
    // and stop color
    mySvg.select("#zeroStop")
      .attr("stop-color", myChart.props.colour);
      
    // y axis - definition and styles
    mySvg.select('#yAxis' + myClass)
      .call(d3.axisLeft(yScaleMain).tickSizeOuter(0).ticks(parseInt(yMaxMain) < 3 ? parseInt(yMaxMain) : 6, myChart.props.yAxisFormat))
      .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')');

    mySvg.selectAll('#yAxis' + myClass + ' line')
      .attr('x1', '0')
      .attr('x2', width - margins.right - margins.left)
      .style('stroke', '#F0F3F6')
      .style('stroke-width', 1);

    mySvg.selectAll('#yAxis' + myClass + ' text')
     .style('fill', '#101D42')
      .style('font-size', '12px')
      // .text((d: any) => +d > 0 ? d : "")
      
     mySvg.select('#yAxisRight' + myClass)
        .call(d3.axisRight(yScaleRight).tickSizeOuter(0).ticks(parseInt(yMaxBar) < 3 ? parseInt(yMaxBar) : 6, myChart.props.yAxisFormat))
        .attr('transform', 'translate(' + (width - margins.right) + ',' + margins.top + ')');

      // style the right axis text
      mySvg.selectAll('#yAxisRight' + myClass + ' text')
        .style('fill', '#101D42')
        .style('font-size', '12px');
            // remove axis ticks (optional if you don't want them crossing)
      mySvg.selectAll('#yAxisRight' + myClass + ' line')
        .style('stroke', 'none');

    // draw chart
    drawChart();

    function drawChart(){
      // --- FIND TOP 2 MAX VALUES ---
      // sort descending
      // const sorted = [...dateGroupMain].sort((a, b) => b[1] - a[1]);
      // // get top 2 unique values
      // const uniqueValues: number[] = [];
      // for (const d of sorted) {
      //   if (!uniqueValues.includes(d[1])) {
      //     uniqueValues.push(d[1]);
      //   }
      //   if (uniqueValues.length >= 2) break;
      // }

      // // map value → color
      // const valueToColor = new Map<number, string>();
      // const colors = ['red', 'orange'];
      // uniqueValues.forEach((val, i) => valueToColor.set(val, colors[i]));

      // const topLines = sorted.filter(d => valueToColor.has(d[1]));

      // mySvg.selectAll('.maxLine' + myClass)
      //   .data(topLines)
      //   .join('line')
      //   .attr('class', 'maxLine' + myClass)
      //   .attr('x1', (d: any) => xScale(d[0]) + margins.left)
      //   .attr('x2', (d: any) => xScale(d[0]) + margins.left)
      //   .attr('y1', (d: any) => yScaleMain(d[1]) + margins.top)
      //   .attr('y2', height - margins.bottom)
      //   .attr('stroke', (d: any) => valueToColor.get(d[1])!)
      //   .attr('stroke-width', 2)
      //   .attr('stroke-dasharray', '4,4')
      //   .attr('clip-path', 'url(#bmlBrushClip' + myClass + ')');

      // draw chart function
      // everything in here changes in response to the brush
      
      // --- BAR CHART ---
      // Calculate bar positions - positioned first so bars appear behind
      mySvg.select('#barGroup' + myClass)
        .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')')
        .selectAll('.bar' + myClass)
        .data(dateGroupBar, (d: any) => d[0])
        .join(
          (enter: any) => enter.append('rect')
            .attr('class', 'bar' + myClass)
            .attr('fill', myChart.props.barColor || '#5D8AA8') // Dynamic bar color
            .attr('opacity', myChart.props.barOpacity || 0.6) // Dynamic bar opacity
            .attr('clip-path', 'url(#bmlBrushClip' + myClass + ')'),
          (update: any) => update,
          (exit: any) => exit.remove()
        )
        .attr('x', (d: any, i: any) => {
          // Center the bar on the data point
          const centerX = xScale(d[0]);
          return centerX - (myChart.props.barWidth || barWidth) / 2;
        })
        .attr('y', (d: any) => yScaleRight(d[1]))
        .attr('width', myChart.props.barWidth || barWidth) // Dynamic bar width
        .attr('height', (d: any) => height - margins.top - margins.bottom - yScaleRight(d[1]))
        .on("mousemove", (event: any, d: any) => {
          mySvg.select('.barMouseoverLine' + myClass)
            .attr("visibility", "visible")
            .attr('stroke', '#1468E1')
            .attr("x1", margins.left + xScale(d[0]))
            .attr("y1", margins.top + yScaleRight(d[1]))
            .attr("y2", margins.top + yScaleRight(d[1]));
  
          mySvg.select('.barMouseoverRect' + myClass)
            .attr("visibility", "visible")
            .attr('fill', '#1468E1')
            .attr("y", margins.top + yScaleRight(d[1]) - 6);
  
          mySvg.select('.barMouseoverText' + myClass)
            .attr("visibility", "visible")
            .attr("y", margins.top + yScaleRight(d[1]))
            .text(d3.format("-2~")(d[1]));

         const xPosition = xScale(d[0]) + margins.left;
         createVerticalLine(mySvg, xPosition, margins, height);
          myChart.showTooltip(event, d, event.offsetX, event.offsetY);
         })
         .on('mouseout', () => { 
           mySvg.selectAll('.barMouseoverItem' + myClass).attr("visibility", "hidden");
          removeVerticalLine();
          myChart.hideTooltip(event); });


      // [NEW] --- BAR VALUE LABELS ---
      // Find the corresponding data from allData to get the specific value for each bar
      const barValueData = dateGroupBar.map(([date, value]:any) => {
          // Find the original data point matching the date
          const originalDataPoint = allData.find((d:any) => new Date(d[myChart.props.xAxisVar]).getTime() === date.getTime());
          return {
              date: date,
              value: originalDataPoint ? originalDataPoint[myChart.props.barVar] : 0 // Use the value from allData
          };
      });

      mySvg.select('#barValueLabels' + myClass)
        .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')')
        .selectAll('.barValueLabel' + myClass)
        .data(barValueData, (d: any) => d.date) // Use date as key
        .join(
          (enter: any) => enter.append('text')
            .attr('class', 'barValueLabel' + myClass)
            .attr('text-anchor', 'middle') // Center text horizontally
            .attr('dominant-baseline', 'hanging') // Align text to top
            .style('font-size', '10px')
            .style('font-family', 'Poppins')
            .style('font-weight', 500)
            .style('fill', 'black') // Or another color as needed
            .attr('clip-path', 'url(#bmlBrushClip' + myClass + ')'),
          (update: any) => update,
          (exit: any) => exit.remove()
        )
        .attr('x', (d: any) => xScale(d.date)) // Position at the center of the bar
        .attr('y', (d: any) => yScaleRight(d.value) - 15) // Position slightly above the top of the bar
        .text((d: any) => d.value); // Display the value


    // Dynamic lines - drawn above bars, below main line unless you raise()
if (myChart.props.dynamicLines && Array.isArray(myChart.props.dynamicLines)) {
  
  myChart.props.dynamicLines.forEach((_line: any, index: number) => {

    const lineData = Array.from(
      d3.rollup(
        allData,
        (r: any) => d3.sum(r, (s: any) => s[_line.var]),
        (g: any) => g.date
      )
    );

    const pathId = `dynamicLinePath_${index}_${_line.var}${myClass}`;

    const lineGroup = mySvg.select('#barGroup' + myClass);

    lineGroup
      .selectAll(`#${pathId}`)
      .data([lineData])
      .join(
        (enter:any) => enter.append('path').attr('id', pathId),
        (update:any) => update
      )
      .attr('d', line(lineData))
      .attr('fill', 'transparent')
      .style("pointer-events", "stroke")
      .attr('stroke', _line.color || '#FF5757')
      .attr('stroke-width', _line.width || 4)
      .attr('clip-path', 'url(#bmlBrushClip' + myClass + ')')
      // .attr('transform', `translate(${margins.left},${margins.top})`)
      .on('mousemove', (event: any,d:any) => {
        const [mouseX] = d3.pointer(event, mySvg.node());

        // convert to date
        const hoveredDate = xScale.invert(mouseX - margins.left);

        // find nearest point
        const i = d3.bisector((d: any) => d[0]).center(lineData, hoveredDate);
        const point = lineData[i];
        if (!point) return;
        mySvg.select('.lineMouseoverLine' + myClass)
          .attr('visibility', 'visible')
          .attr('stroke', _line.color || '#FF5757')
          .attr('x1', margins.left)
          .attr('x2', margins.left + xScale(point[0]))
          .attr('y1', margins.top + yScaleMain(point[1]))
          .attr('y2', margins.top + yScaleMain(point[1]));

        mySvg.select('.lineMouseoverRect' + myClass)
          .attr('visibility', 'visible')
          .attr('fill', _line.color || '#FF5757')
          .attr('x', margins.left - 42)
          .attr('y', margins.top + yScaleMain(point[1]) - 6);

        mySvg.select('.lineMouseoverText' + myClass)
          .attr('visibility', 'visible')
          .attr('x', margins.left - 20)
          .attr('y', margins.top + yScaleMain(point[1]))
          .text(d3.format('-2~')(point[1]));
        const xPosition = xScale(point[0]) + margins.left;
        const yPosition = yScaleMain(point[1]) + margins.top;

        createVerticalLine(mySvg, xPosition, margins, height);

        myChart.showTooltip(event, point, event.offsetX, event.offsetY);
      })

      .on('mouseout', () => {
        mySvg.selectAll('.barMouseoverItem' + myClass).attr('visibility', 'hidden');
         mySvg.selectAll('.lineMouseoverItem' + myClass).attr('visibility', 'hidden');
        removeVerticalLine();
        myChart.hideTooltip(event);
      });


    const dotsGroup = mySvg.select('#dotsGroup' + myClass);
    dotsGroup
     .attr('transform', `translate(${margins.left},${margins.top})`);
    dotsGroup
      .selectAll(`.dot${index}${myClass}`)
      .data(lineData, (d: any, i: number) => `${i}-${d[0]}`)
      .join(
        (enter:any) => enter.append('circle').attr('class', `dot${index}${myClass}`),
        (update:any) => update,
        (exit:any) => exit.remove()
      )
      .attr('r', 4)
      .attr('stroke', _line.color || '#FF5757')
      .attr('stroke-width', 3)
      .attr('fill', '#fff')
      .attr('clip-path', 'url(#bmlBrushClip' + myClass + ')')
      .attr('cx', (d: any) =>  xScale(d[0]))
      .attr('cy', (d: any) =>  yScaleMain(d[1]))
      .on('mousemove', (event: any, d: any) => {
        
        mySvg.select('.lineMouseoverLine' + myClass)
          .attr('visibility', 'visible')
          .attr('stroke', _line.color || '#FF5757')
          .attr('x1', margins.left)
          .attr('x2', margins.left + xScale(d[0]))
          .attr('y1', margins.top + yScaleMain(d[1]))
          .attr('y2', margins.top + yScaleMain(d[1]));

        mySvg.select('.lineMouseoverRect' + myClass)
          .attr('visibility', 'visible')
          .attr('fill', _line.color || '#FF5757')
          .attr('x', margins.left - 42)
          .attr('y', margins.top + yScaleMain(d[1]) - 6);

        mySvg.select('.lineMouseoverText' + myClass)
          .attr('visibility', 'visible')
          .attr('x', margins.left - 20)
          .attr('y', margins.top + yScaleMain(d[1]))
          .text(d3.format('-2~')(d[1]));

        const xPosition = xScale(d[0]) + margins.left;
        createVerticalLine(mySvg, xPosition, margins, height);

        myChart.showTooltip(event, d, event.offsetX, event.offsetY);
      })
      .on('mouseout', () => {
        mySvg.selectAll('.lineMouseoverItem' + myClass).attr('visibility', 'hidden');
        removeVerticalLine();
        myChart.hideTooltip(event);
      });
  });
}

      const removeVerticalLine = () => {
  d3.select('#vertical-line').remove();
};
const createVerticalLine = (svg: any, xPosition: number, margins: any, height: number) => {
  // Remove any existing vertical line
  d3.select('#vertical-line').remove();
  
  // Add vertical dotted line
  return svg.append('line')
    .attr('id', 'vertical-line')
    .attr('x1', xPosition)
    .attr('y1', margins.top)
    .attr('x2', xPosition)
    .attr('y2', height - margins.bottom)
    .attr('stroke', '#666')
    .attr('stroke-dasharray', '4,4')
    .attr('stroke-width', 1);
};
      // [FIX] Draw the main line if showMainLine is true (or if no dynamic lines exist, as fallback)
      // Ensure the main line is drawn even if dynamic lines exist, based on the flag
      if (myChart.props.showMainLine !== false) { // Default to true if undefined
        // console.log("Drawing Main Line with data:", dateGroupMain); // [DEBUG]
        // console.log("Line Path ID: ", 'linePath' + myClass); // [DEBUG].

        // main line path (note clip path) - positioned after bars so it appears on top
        mySvg.select('#linePath' + myClass)
          .attr('clip-path','url(#bmlBrushClip' + myClass + ')')
          .attr('d', line(dateGroupMain)) // Calculate path using the line generator
          .attr('fill', 'transparent') // Ensure no fill
          .attr('stroke', myChart.props.colour) // Use the specified color
          .attr('stroke-width', '4px') // Use the specified width
          .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')');
          
        // --- ADD DATA DOTS ---
        mySvg.selectAll('.dot' + myClass)
          .data(dateGroupMain, (d: any) => d[0]) // key function (date or x-value)
          .join(
            (enter:any) => enter.append('circle')
              .attr('class', 'dot' + myClass)
              .attr('r', 4)
              .attr('stroke',myChart.props.colour )
              .attr('stroke-width', 3)
              .attr('fill','#fff' )
              .attr('clip-path', 'url(#bmlBrushClip' + myClass + ')'), // ✅ clip path
            (update:any) => update,
            (exit:any) => exit.remove()
          )
          .attr('cx', (d: any) => xScale(d[0]) + margins.left)
          .attr('cy', (d: any) => yScaleMain(d[1]) + margins.top);
      } else {
        // console.log("Hiding Main Line based on showMainLine flag"); // [DEBUG]
        // If showMainLine is explicitly false, hide the main line and dots
        mySvg.select('#linePath' + myClass).attr('d', '');
        mySvg.selectAll('.dot' + myClass).remove();
      }

      // --- TEXT LABELS (optional) ---
      // mySvg.selectAll('.label' + myClass)
      //   .data(dateGroupMain, (d: any) => d[0])
      //   .join(
      //     (enter:any) => enter.append('text')
      //       .attr('class', 'label' + myClass)
      //       .attr('text-anchor', 'middle')
      //       .style('font-size', '12px')
      //       .style('font-family', 'Poppins')
      //       .style('font-weight', 500)
      //       .style('fill', 'black')
      //       .attr('clip-path', 'url(#bmlBrushClip' + myClass + ')'), // ✅ clip path
      //     (update:any) => update,
      //     (exit:any) => exit.remove()
      //   )
      //   .attr('x', (d: any) => xScale(d[0]) + margins.left)
      //   .attr('y', (d: any) => yScaleMain(d[1]) + margins.top - 10) // above dot
      //   .text((d: any) => d[1]);

      // area path (note clip path) - positioned after bars so it appears on top
      // mySvg.select('#areaPath' + myClass)
      //   .attr('clip-path','url(#bmlBrushClip' + myClass + ')')
      //   .attr('d', area(dateGroupMain))
      //   .attr('stroke', 'transparent')
      //   .attr('fill', 'url(#area-gradient)')
      //   .attr('fill-opacity', 0.4)
      //   .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')');
        
      // x axis - define and style
      mySvg.select('#xAxis' + myClass)
        // @ts-ignore
        .call(d3.axisBottom(xScale).tickSizeOuter(0).tickValues(dateGroupDates).ticks(6).tickFormat(xTickFormat))
        .attr('transform', 'translate(' + margins.left + ',' + (height - margins.bottom) + ')').attr('clip-path', 'url(#bmlBrushClip' + myClass + ')');

      mySvg.selectAll('#xAxis' + myClass + ' line')
        .attr('display', 'none');

      mySvg.selectAll('.axis' + myClass + ' path')
        .style('stroke', '#E8EAEE');

      mySvg.selectAll('.axis' + myClass + ' text')
        .style('font-family', 'Poppins')
        .style('font-weight', 500)
        .style('font-size', 10)
        .attr("y", 3);

      // this is a cheat to make sure labels do not overlap
      // Sitaram wants a label for each 'tick' (see brush + line chart)
      // but I do not think there is enough space for this
      const xTicks = xScale.ticks(3);

      mySvg.selectAll('#xAxis' + myClass + ' text')
        .text((d: any, i: any) => {
          // hide the LAST tick IF
          // d3 has chosen to show more than 3 ticks
          // AND it is 1st or 2nd day of the month
          // Overlap only occurs in this case as spacing is not even
          if(i < (xTicks.length - 1) || xTicks.length <= 3 || !lastDay1Or2){
            return xTickFormat(d);
          }
          return ""
        });
    }

function brushed(event: any): void {
  const selection = event.selection;
  if (!selection) return;

  let [x0, x1] = selection;

  // -------------------------------------
  // BOUNDARY LIMITS
  // -------------------------------------
  const MIN_X = 0;
  const MAX_X = width - margins.left - margins.right;

  // Clamp to boundaries
  x0 = Math.max(MIN_X, x0);
  x1 = Math.min(MAX_X, x1);

  // -------------------------------------
  // MINIMUM WIDTH RESTRICTION
  // -------------------------------------
  const MIN_WIDTH_PX = 100;

  // If too small → enforce minimum width
  if ((x1 - x0) < MIN_WIDTH_PX) {
    x1 = x0 + MIN_WIDTH_PX;

    // If enforcing pushes x1 beyond right boundary -> shift left
    if (x1 > MAX_X) {
      x1 = MAX_X;
      x0 = x1 - MIN_WIDTH_PX;
    }

    d3.select('#brushGroup' + myClass)
      .call(brush.move, [x0, x1]);

    return;
  }

  // -------------------------------------
  // HANDLE CROSS PREVENTION
  // -------------------------------------
  if (x0 >= x1) {
    x1 = x0 + MIN_WIDTH_PX;
    d3.select('#brushGroup' + myClass)
      .call(brush.move, [x0, x1]);
    return;
  }

  // -------------------------------------
  // VALID SELECTION → UPDATE CHART
  // -------------------------------------

  d3.select('#mouseoverLine' + myClass).attr('visibility', 'hidden');
  d3.select('#mouseoverDot' + myClass).attr('visibility', 'hidden');
  myChart.hideTooltip('lineDot');

  const xDomain = [xScaleAll.invert(x0), xScaleAll.invert(x1)];
  xScale.domain(xDomain);

  drawChart();

  // -------------------------------------
  // UPDATE HANDLE POSITION VISUALS
  // -------------------------------------
  const brushGroup = mySvg.select('#brushGroup' + myClass);

  const handleEastX = +brushGroup.select('.handle--e').attr('x');
  const handleWestX = +brushGroup.select('.handle--w').attr('x');

  mySvg.select('.handleLeftLine1' + myClass)
    .attr('x1', handleEastX + 3)
    .attr('x2', handleEastX + 3);

  mySvg.select('.handleLeftLine2' + myClass)
    .attr('x1', handleEastX + 7)
    .attr('x2', handleEastX + 7);

  mySvg.select('.handleRightLine1' + myClass)
    .attr('x1', handleWestX + 3)
    .attr('x2', handleWestX + 3);

  mySvg.select('.handleRightLine2' + myClass)
    .attr('x1', handleWestX + 7)
    .attr('x2', handleWestX + 7);

  brushGroup.selectAll('.handle')
    .attr('fill', 'white')
    .attr('rx', 4)
    .attr('ry', 4)
    .attr('y', (margins.brush - 24) / 2)
    .attr('height', 24)
    .style('filter', 'url(#drop-shadow)');
}



    
    // used multiple times
  function measureWidth(myText: any, myFontSize: any): any {
    const context: any = document.createElement('canvas').getContext('2d');
    context.font = myFontSize + 'px sans-serif';
    return context.measureText(myText).width;
  }
  function drawLegend(legendData: any) {

      const legendGroup = mySvg
        .selectAll('.legendGroup' + myClass)
        .data(legendData)
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'legendGroup' + myClass);
          enter.append('circle').attr('class', 'legendCircle');
          enter.append('text').attr('class', 'legendLabel');
          return enter;
        });

      legendGroup.attr("transform", "translate(" + (margins.left) + ",15)");

      legendGroup.select('.legendCircle')
        .attr('id', (d: any) => 'circle_legendItem' + d)
        .attr('fill', (d: any) => myChart.props.barFill[d])
        .attr('r', 4);

      legendGroup.select('.legendLabel')
        .attr('id', (d: any) => 'legendItem' + d)
        .attr('y', 5)
        .attr('fill', '#101D42')
        .attr('font-weight', '500')
        .attr('font-size', '12')
        .attr('font-family', 'Poppins')
        .text((d: any) => myChart.props.barLabels[d]?.toUpperCase())
      let legendX = 0;
      mySvg.selectAll('.legendLabel').each(function (): any {
        //@ts-ignore
        const myObject = this;
        const myWidth: any = document.getElementById(myObject.id)?.getBoundingClientRect().width;
        d3.select(myObject).attr('x', legendX + 12);
        mySvg.select('#circle_' + myObject.id).attr('cx', legendX);  
        legendX += (40 + myWidth)
      });
      legendGroup.attr('transform', 'translate(' + ((width - legendX + 24) / 2) + ',15)');
    
    }
  }
  
  loadApiData() {
    this.loader = true;
    let designerVar = this.params?.['designerCellRendererParams'] || {};
    this.props = {
      sourceName: 'RxCrossroads',
      locationName: 'IRVING, TX',

      chartHeight: 350,
      xAxisVar:  designerVar?.xAxis || 'period',
      yAxisVar: 'unlinked_patient_volume_month', // Purple line
      barVar: designerVar?.barVar || 'total_triaged_patients', // Light blue bars
      sourceVar: designerVar?.sourceVar || "source_name",
      locationVar: "LocationName",
      colour: '#BB7EDA', // Purple line color
      barColor: designerVar?.barColor || '#B0D4F0', // Light blue bar color
      barOpacity: designerVar?.barOpacity || 0.7,
      barWidth: designerVar?.barWidth || 50,
      barPadding: designerVar?.barPadding || 0.1,
      period: this.filterService.report_type || 'M',
      xAxisLabel: "",
      yAxisLabel: "Unlinked Patient Volume",
      yAxisLabelRight: "Total Triaged Patients",
      yAxisFormat: '.2~s',
      showBrush: true,
      legendLable: designerVar?.labelVar || 'Unlinked Patient Volume',
      // [FIX] Add showMainLine property, defaulting to true
      showMainLine: false, // Explicitly check for false
      // Dynamic lines configuration
      dynamicLines: designerVar?.dynamicLines || [
        {
          var: 'unlinked_patient_volume_current', // Red line
          color: '#FF5757',
          width: '4px',
          label: 'Unlinked Patient Volume (As of Today)'
        },
        {
          var: 'unlinked_patient_volume_month', // Purple line (different from main line)
          color: '#BB7EDA',
          width: '4px',
          label: 'Unlinked Patient Volume (As of Month-End)'
        }
      ],
      barFill:  {'total_triaged_patients':'#B0D4F0','unlinked_patient_volume_current':'#FF5757','unlinked_patient_volume_month':'#BB7EDA'},
      barLabels:  {'total_triaged_patients':'Total Triaged Patients (As of Today)','unlinked_patient_volume_current':'Unlinked Patient Volume (As of Today)','unlinked_patient_volume_month':'Unlinked Patient Volume (As of Month-End)'},
    }

    // console.log("Props initialized in loadApiData: ", this.props); // [DEBUG]

    if(this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {
      let obj:any = {"api_key" : designerVar?.apiKey || 200228}

      let query1 = Object.assign({}, this.filterService.baseQuery, obj)
      query1["report_typ"] = this.filterService.report_type;
      query1["source_key"] = this.params.data['source_key'];
      this.error_name = '';
      
      let endpoint = designerVar?.endpoint;

      this.reqSubcription.push(
        this.apiService.post(`${endpoint ? endpoint : this.apiService.executionUrl}`, query1).subscribe((res:any)=> {
          this.loader = false;
          let resData:any = res == null ? [] : res;
          if(resData.length>0) {
            // Modified data structure to match the chart visualization
            // Ensure the keys here match xAxisVar, yAxisVar, barVar in props
            this.bubblemaplinechartdata = resData
            // console.log("Sample Data Loaded: ", this.bubblemaplinechartdata); // [DEBUG]
            function removeZeroVariables(props:any, data: any[]) {
                // Helper function to check if all values are zero/null/undefined
                const isAllZero = (varName: string) => 
                    data.every(item => [0, null, undefined].includes(item[varName]));
                
                // Get all variable names that need to be checked
                const allVarNames = [
                    ...props.dynamicLines.map((line:any) => line.var),
                    ...Object.keys(props.barFill),
                    ...Object.keys(props.barLabels)
                ].filter((v, i, arr) => arr.indexOf(v) === i); // unique values only
                
                // Find variables to remove
                const varsToRemove = allVarNames.filter(varName => isAllZero(varName));
                
                // Create cleaned props
                return {
                    dynamicLines: props.dynamicLines.filter((line:any) => !varsToRemove.includes(line.var)),
                    barFill: Object.fromEntries(
                        Object.entries(props.barFill).filter(([key]) => !varsToRemove.includes(key))
                    ),
                    barLabels: Object.fromEntries(
                        Object.entries(props.barLabels).filter(([key]) => !varsToRemove.includes(key))
                    )
                };
            }

            // Usage
            const cleanedProps = removeZeroVariables(this.props, this.bubblemaplinechartdata);
            this.props= { ...this.props, ...cleanedProps };
            this.props.yAxisLabel=this.props.dynamicLines.length==0 ? " " :this.props.yAxisLabel;
            this.plotChart();
          } else {
            this.bubblemaplinechartdata = [];
          }
          this.error_name = 'There is no data for this time period';
          this.cdr.detectChanges()
          
        },(err:any)=>{
          this.loader = false;
          this.bubblemaplinechartdata = [];
          this.error_name =   err?.error?.error?.message || err?.error?.message || err?.message || ''
          this.cdr.detectChanges()
        })
      )
    }
  }
}